module.exports = __webpack_public_path__ + "static/media/typeAVersion1.801a2d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotspots/landing/typeAVersion1.png
// module id = 1245
// module chunks = 0